import type { FrameData } from "@/lib/frame-data";

/**
 * What every frame component receives, wherever it renders: the canvas
 * adapts React Flow's node props to these, any other surface builds them
 * from frame data directly.
 */
export interface FrameProps {
  id: string;
  data: FrameData;
  selected: boolean;
  width?: number;
  height?: number;
}

function shallowEqualData(
  a: Record<string, unknown>,
  b: Record<string, unknown>,
): boolean {
  const keysA = Object.keys(a);
  if (keysA.length !== Object.keys(b).length) return false;
  for (const key of keysA) {
    if (!Object.is(a[key], b[key])) return false;
  }
  return true;
}

/** Memo comparison for frame components: frame data is compared shallowly. */
export function framePropsAreEqual(
  prev: FrameProps,
  next: FrameProps,
): boolean {
  if (prev === next) return true;
  if (prev.id !== next.id) return false;
  if (prev.selected !== next.selected) return false;
  if (prev.width !== next.width) return false;
  if (prev.height !== next.height) return false;
  if (prev.data === next.data) return true;
  return shallowEqualData(prev.data, next.data);
}
